export const environment = {
  production: true,
  apiHost: 'https://makpak.allianz.de/prod/edge',
  apiUrl: 'api',
  backUrl: 'https://makler.allianz.de',
  ssoLoginUrl: 'https://ltp.allianz.de/ui/de/nova/login',
  ssoTargetKey: '72868fd1',
};
